export default __webpack_public_path__ + "static/media/empty-board.2d1dc232.svg";